import type { SVGProps } from "react";

export function Logo({ ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" viewBox="0 0 872 157" xmlns="http://www.w3.org/2000/svg" {...props}>
      <image className="dark:hidden" height="157" href="/svg/logo/full-lockup-dark.svg" width="872" />
      <image className="hidden dark:inline" height="157" href="/svg/logo/full-lockup-light.svg" width="872" />
    </svg>
  );
}
